import { put, takeLatest, delay } from "redux-saga/effects";
import { getListProductsApi } from "store/api/OrderApi";
import { GET_LIST_PRODUCTS_ACTION } from "../../actions/OrderPageAction/actionTypes";

import * as orderPageAction from "../../actions/OrderPageAction";
import * as globalAction from "../../actions/GlobalAction";

function* errorMessage(message) {
	const alert = { isError: true, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* getListProducts(action) {
	// yield put(globalAction.openLoadingPage());
	const res = yield getListProductsApi(action.params);
	try {
		if (res?.code === 0) {
			yield put(orderPageAction.setListProductAction(res?.data));
		} else {
			yield errorMessage(res?.message);
		}
		yield delay(500);
	} catch (e) {
		console.log(e);
	} finally {
		// yield put(globalAction.closeLoadingPage());
	}
}

function* getListProductsSaga() {
	yield takeLatest(GET_LIST_PRODUCTS_ACTION, getListProducts);
}

export default getListProductsSaga;
